import {
  CALLBACK_BUTTON_TEXT_EXPERIMENT,
  NEWBUILDING_WINNER_EXPERIMENT,
  WEB_3D_TOURS_EXPERIMENT,
  NEWBUILDING_PRICE_PLATE_EXPERIMENT,
} from 'shared/selectors/abExperiments';
import { NEWBUILDING_TRUST_AND_SAFETY } from 'shared/selectors/abExperiments/selectIsNewbuildingReliabilityEnabled';
import { MY_HOME_HOMEOWNER_TRAP_EXPERIMENT, MY_HOME_TRAP_BANNER_EXPERIMENT } from 'shared/selectors/valuationTraps';

import { CALLTRACKING_WARNING } from '../../experiments/calltrackingWarning';
import { NEWBUILDING_CPM_FORMAT_IN_CARD_EXPERIMENT } from '../../selectors/abExperiments/selectNewbuildingCpmFormatInCard';
import { HOUSE_CARD_URL_EXPERIMENT } from '../../utils/experiments/houseCardUrl';

export const AA_TEST_50 = 'aud_desktop_aud2904_split_50_card_aa_expf';
export const AA_TEST_30 = 'aud_desktop_aud2904_split_30_card_aa_expf';

export const NEWBUILDING_AA_TEST_50 = 'newbuiliding_test_for_expf_desktop_50_50';
export const NEWBUILDING_AA_TEST_30 = 'newbuiliding_test_for_expf_desktop_70_30';

export const EXPERIMENTS: string[] = [
  HOUSE_CARD_URL_EXPERIMENT,
  CALLTRACKING_WARNING,
  NEWBUILDING_WINNER_EXPERIMENT,
  WEB_3D_TOURS_EXPERIMENT,
  CALLBACK_BUTTON_TEXT_EXPERIMENT,
  NEWBUILDING_PRICE_PLATE_EXPERIMENT,
  MY_HOME_TRAP_BANNER_EXPERIMENT,
  MY_HOME_HOMEOWNER_TRAP_EXPERIMENT,
  /**
   * @todo Удалить строку с экспериментом
   * @description Данный функционал появился в задаче CD-199718, будет удалён в задаче CD-199865
   */
  NEWBUILDING_CPM_FORMAT_IN_CARD_EXPERIMENT,
  AA_TEST_50,
  AA_TEST_30,
  NEWBUILDING_AA_TEST_50,
  NEWBUILDING_AA_TEST_30,
  NEWBUILDING_TRUST_AND_SAFETY,
];
